
























































































import {
  Component,
  Prop,
  Vue,
  Watch
} from "@/shared/vuepack";
import { Location } from "vue-router";
import {
  UmbAccountUserModel,
  UserListActionButtonOptions
} from "@/admin/types";
import PageSizeSelectList from "@/shared/components/ui/PageSizeSelectList.vue";
import Pagination from "@/shared/components/ui/Pagination.vue";
import { useNotifierStore } from "@/shared/store/notifier";
import { useUmbAccountUserSearchStore } from "@/admin/store/umbAccountUserSearch";

@Component({
  components: {
    PageSizeSelectList,
    Pagination
  }
})
export default class UmbAccountUsers extends Vue {
  notifierStore = useNotifierStore();
  umbAccountUserSearchStore = useUmbAccountUserSearchStore();

  isSubmitting = false;
  searchTerm = "";
  users: UmbAccountUserModel[] = [];

  @Prop({ default: () => ({ show: false, text: "" }) })
  actionButtonOptions: UserListActionButtonOptions;

  @Prop()
  page: number;

  @Prop()
  routeToUserList: (page: number) => Location;

  @Prop({ default: "" })
  subtitle: string;

  @Prop({ default: "UMB Account Users" })
  title: string;

  mounted (): void {
    this.fetchUserList(false);
  }

  get submitDisabled (): boolean {
    return this.umbAccountUserSearchStore.isLoading || this.isSubmitting;
  }

  @Watch("page")
  onRouteValuePageNumberChanged (): void {
    this.fetchUserList(false);
  }

  switchPage (toPage): void {
    this.$router.push(this.routeToUserList(toPage));
  }

  fetchUserList (clearState: boolean): void {
    if (!clearState) {
      this.umbAccountUserSearchStore.setPageNumber(this.page);
    }

    this.umbAccountUserSearchStore.loadUsers({
          clearState,
          pageNumber: this.umbAccountUserSearchStore.pageNumber,
          searchTerm: this.searchTerm
        } as any)
        .then(() => {
          this.users = this.umbAccountUserSearchStore.getUsersByPageNumber(this.umbAccountUserSearchStore.pageNumber);
        })
        .catch(this.handleError);
  }

  onSearch (): void {
    if (this.isSubmitting) {
      return;
    }

    this.isSubmitting = true;
    this.umbAccountUserSearchStore.setPageNumber(1);
    this.$router.push(this.routeToUserList(1));
    this.fetchUserList(true);
    this.isSubmitting = false;
  }

  clearSearch (): void {
    if (this.isSubmitting) {
      return;
    }

    this.isSubmitting = true;
    this.searchTerm = "";
    this.umbAccountUserSearchStore.setPageNumber(1);
    this.$router.push(this.routeToUserList(1));
    this.fetchUserList(true);
    this.isSubmitting = false;
  }

  switchPageSize (): void {
    this.umbAccountUserSearchStore.setPageNumber(1);
    this.$router.push(this.routeToUserList(1));
    this.fetchUserList(true);
  }

  showError (message: string): void {
    this.notifierStore.setDanger(message);
  }

  handleError (err: any): void {
    this.showError(
        (err && err.errorMessage) ||
        "Error processing your request. Please try again later"
    );
  }
}
